import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";

const NurseryGroupForm = (props) => {
  const [groupName, setGroupName] = useState("");
  const [beds, setBeds] = useState("");
  const { sendRequest: postNurseryGroup } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      nurseryGroupSiteName: groupName,
      noOfBeds: beds,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId:props.sId,
    };

    //console.log("data",data);

    if (props.update) {
      data["nurseryGroupSiteId"] = props.update.nurseryGroupSiteId;
    }

    postNurseryGroup(
      {
        url: "/api/nurserygroupsite/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`Nursery Group Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  
  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      setGroupName(props.update.nurseryGroupSiteName);

      setBeds(props.update.noOfBeds);

 
    }
  }, [props.update]);
  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Nursery Group Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Nursery Group Name</label>
                        <input
                          type={"text"}
                          id={"seasonName"}
                          required
                          className="form-control"
                          value={groupName}
                          onChange={(e) => {
                            setGroupName(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>No Of Beds</label>
                        <input
                          type={"text"}
                          id={"seasonName"}
                          required
                          className="form-control"
                          value={beds}
                          onChange={(e) => {
                            setBeds(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default NurseryGroupForm;
